// extracted by mini-css-extract-plugin
export default {"fieldContainer":"ProductComponentBase_fieldContainer__MUML1"};